// extracted by mini-css-extract-plugin
export default {"recos":"Z4-z","productCardOverride":"_4-z","rowHasBadge":"a5-z"};